import { LinkableEntityType } from '@api';
import {
  ArtistAnchor,
  CompanyAnchor,
  FestivalAnchor,
  PersonAnchor,
  TeamAnchor,
  TourAnchor,
  VenueAnchor,
} from '@common';

type LinkableEntityPropsType = {
  linkableEntity: LinkableEntityType;
  children?: React.ReactNode;
};

export const LinkableEntity: React.FC<LinkableEntityPropsType> = ({
  linkableEntity,
  children,
}) => {
  switch (linkableEntity.type) {
    case 'ARTIST':
      return <ArtistAnchor artist={linkableEntity}>{children}</ArtistAnchor>;
    case 'TOUR':
      return <TourAnchor tour={linkableEntity}>{children}</TourAnchor>;
    case 'VENUE':
      return <VenueAnchor venue={linkableEntity}>{children}</VenueAnchor>;
    case 'FESTIVAL':
      return (
        <FestivalAnchor festival={linkableEntity}>{children}</FestivalAnchor>
      );
    case 'COMPANY':
      return <CompanyAnchor company={linkableEntity}>{children}</CompanyAnchor>;
    case 'PERSON':
      return <PersonAnchor person={linkableEntity}>{children}</PersonAnchor>;
    case 'TEAM':
      return <TeamAnchor team={linkableEntity}>{children}</TeamAnchor>;
    default:
      return <span>{children ?? linkableEntity.name}</span>;
  }
};
